export default function PrivacyPage() {
  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '2rem 1rem 4rem' }}>
      <a
        href="/"
        style={{ display: 'inline-block', marginBottom: '2rem', color: 'var(--text-muted)', textDecoration: 'none', fontSize: '0.9rem' }}
      >
        ← Zurück zu Reverend
      </a>

      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, marginBottom: '0.3rem' }}>Datenschutzerklärung</h1>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '2.5rem' }}>Stand: Mai 2026</p>

      <Section title="1. Verantwortlicher">
        <p>Reverend wird betrieben von:<br />Sebastian Cora<br />
          E-Mail: <a href="mailto:sbstncora@gmail.com" style={{ color: 'var(--accent)' }}>sbstncora@gmail.com</a>
        </p>
      </Section>

      <Section title="2. Welche Daten wir erheben">
        <p>Reverend ist auf maximale Anonymität ausgelegt. Wir erheben bewusst so wenig wie möglich:</p>
        <ul style={{ paddingLeft: '1.4rem', marginTop: '0.5rem' }}>
          <li><strong>IP-Adresse (gehasht):</strong> Deine IP-Adresse wird mit HMAC-SHA-256 gehasht und dient ausschließlich zur Erkennung von Doppelabstimmungen. Der Klartext wird nie gespeichert.</li>
          <li style={{ marginTop: '0.4rem' }}><strong>Geständnis-Text:</strong> Der eingegebene Text wird in unserer Datenbank gespeichert und dort dauerhaft aufbewahrt, solange du keine Löschung verlangst.</li>
          <li style={{ marginTop: '0.4rem' }}><strong>Kategorie und Zeitstempel:</strong> Werden zusammen mit dem Text gespeichert.</li>
        </ul>
      </Section>

      <Section title="3. Zahlungsdaten (optionales Pinnen)">
        <p>Das Pinnen eines Geständnisses (0,99 €) erfolgt über <strong>Stripe</strong>. Zahlungsdaten werden ausschließlich von Stripe verarbeitet und gelangen nie auf unsere Server. Wir erhalten nur eine Zahlungsbestätigung.</p>
      </Section>

      <Section title="4. Hosting & Infrastruktur">
        <p>Das Frontend wird über <strong>Vercel</strong> ausgeliefert. Vercel kann im Rahmen des Betriebs technische Zugriffslogs (inkl. IP-Adressen) kurzzeitig speichern.</p>
      </Section>

      <Section title="5. Cookies & Tracking">
        <p>Reverend verwendet <strong>keine</strong> Tracking-Cookies, keine Analytics und keine Social-Media-Einbindungen. Es werden keine personenbezogenen Nutzerprofile erstellt.</p>
      </Section>

      <Section title="6. Speicherdauer & Löschung">
        <p>Geständnisse werden <strong>dauerhaft</strong> gespeichert und bleiben über den Feed sowie ihren Permalink abrufbar. Es findet keine automatische Löschung nach einer festen Frist statt.</p>
        <p style={{ marginTop: '0.5rem' }}>Du kannst die Löschung eines Geständnisses jederzeit formlos per E-Mail verlangen; wir entfernen es dann zeitnah. Gemeldete Inhalte, die gegen unsere Regeln verstoßen, werden ebenfalls entfernt.</p>
      </Section>

      <Section title="7. Deine Rechte (DSGVO)">
        <p>Da Geständnisse anonym sind, ist eine Zuordnung in der Regel nicht möglich. Du hast dennoch folgende Rechte: Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch und Beschwerde bei einer Datenschutzbehörde.</p>
        <p style={{ marginTop: '0.5rem' }}>Kontakt: <a href="mailto:sbstncora@gmail.com" style={{ color: 'var(--accent)' }}>sbstncora@gmail.com</a></p>
      </Section>

      <Section title="8. Rechtsgrundlage">
        <p>Verarbeitung des gehashten IP-Wertes: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse). Speicherung des Geständnis-Textes: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).</p>
      </Section>

      <hr style={{ border: 'none', borderTop: '1px solid var(--border)', margin: '2rem 0' }} />
      <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
        Fragen oder Löschanfragen: <a href="mailto:sbstncora@gmail.com" style={{ color: 'var(--accent)' }}>sbstncora@gmail.com</a>
      </p>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '1.8rem' }}>
      <h2 style={{ fontSize: '1.05rem', fontWeight: 600, color: '#fff', marginBottom: '0.6rem' }}>{title}</h2>
      <div style={{ color: 'var(--text-muted)', lineHeight: 1.7 }}>{children}</div>
    </div>
  )
}
